import { Component, Input, OnInit } from '@angular/core';
import {
  WagtailPageContentElementInterface,
  WagtailShopRichtextRendererInterface
} from "@gea-waldviertler-website/gea-models";

@Component({
    selector: 'wagtail-page-element-shop-richtext',
    templateUrl: './shop-richtext.component.html',
    styleUrls: ['./shop-richtext.component.scss'],
    standalone: false
})
export class ShopRichtextComponent implements OnInit {
  @Input() definition?: WagtailPageContentElementInterface<WagtailShopRichtextRendererInterface>
  content?: WagtailShopRichtextRendererInterface
  unicodeChar: string | undefined

  ngOnInit(): void {
    if (this.definition) {
      this.content = this.definition.value
      if (this.content.unicode) {
        this.unicodeChar = '&#x' + parseInt(''+this.content.unicode).toString(16)  + ';'
      }
    }
  }
}
